import { DynamicNumber, importDynamicNumber } from '../../../lib/defs/types';
import { pixiVectorFromAngle } from '../../../lib/pixi/pixiTools';
import { floatRandom } from '../../../lib/util/mathTools';
import { Particle } from '../Particle';
import { IBehavior } from './IBehavior';

// types
//-----------------------------------------------------------------------------
export type ExplodeBehaviorOptions = {
  type: 'explode';
  magnitude: DynamicNumber;
  applyRotation?: boolean;
  rotationOffset?: number;
};

/*
    radial explosion. set initial velocity to add direction.
*/
export class ExplodeBehavior implements IBehavior {
  // fields
  //-------------------------------------------------------------------------
  private _particle: Particle;
  private _options: ExplodeBehaviorOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(particle: Particle, options: ExplodeBehaviorOptions) {
    this._particle = particle;
    this._options = options;
  }

  // impl
  //-------------------------------------------------------------------------
  public start() {
    const angle = floatRandom(0, Math.PI * 2);

    // solve magnitude
    const magnitude = importDynamicNumber(this._options.magnitude);

    // create random velocity
    this._particle.velocity.add(
      pixiVectorFromAngle(angle).multiplyScalar(magnitude),
    );

    if (this._options.applyRotation) {
      const offset = this._options.rotationOffset ?? 0;
      this._particle.rotation = -angle + offset;
    }
  }
}
